import React from "react";

const ManageSectionsAndQuestions = () => {
  return (
    <div className="utah-design-system page-container">
      <h3>Manage Sections and Questions</h3>
    </div>
  );
};

export default ManageSectionsAndQuestions;
